export default __webpack_public_path__ + "static/media/1617 knife block A top.53a5805c.png";